import { Component, OnInit } from '@angular/core';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { CommonUtil } from '../../core/Utils/common-util';
import { ToastMessageService } from '../../core/shared-service/toast-message.service';
import { LandingApproveDenyRequestService } from '../services/landing-approve-deny-request.service';
import { IApproveDenyInput } from '../services/pre-login.model';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css'],
})
export class LandingComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  isRtl: boolean;
  jsonToSend: IApproveDenyInput;

  constructor(
    private rootScopeService: RootScopeService,
    private toastMessageService: ToastMessageService,
    private approveDenyRequest: LandingApproveDenyRequestService,
    public commonUtil: CommonUtil
  ) {
    this.getRootScopeData();
    this.rootScopeData.pageName = 'Landing';
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  ngOnInit() {
    this.verifyTokenFromEmail();
    this.changeToRtl();
  }

  changeToRtl(): void {
    const selectedLang = this.rootScopeData.selectedLang;
    this.isRtl = false;
    if (selectedLang === 'ar' || selectedLang === 'he') {
      this.isRtl = true;
    }
  }
  verifyTokenFromEmail() {
    if (
      localStorage.getItem('userRequestedURL') != null &&
      typeof localStorage.getItem('userRequestedURL') != undefined
    ) {
      const requestedURL = localStorage.getItem('userRequestedURL') as string;
      if (requestedURL.indexOf('token=') > -1) {
        const originalToken = atob(requestedURL.split('token=')[1]);
        const tokenArr = originalToken.split('&');
        if (tokenArr.length >= 5) {
          if (tokenArr[4] === 'N') {
            this.jsonToSend.facilityId = tokenArr[2];
            this.jsonToSend.userId = tokenArr[1];
            this.jsonToSend.adminId = tokenArr[0];
            const approveFlag = false;
            this.approveDenyRequest.post(this.jsonToSend, approveFlag).subscribe(
              (data) => {
                this.toastMessageService.emitChange(
                  this.commonUtil.translateText('ACCESS.DENIED.MSG' + tokenArr[3]) + 'success'
                );
                localStorage.removeItem('userRequestedURL');
              },
              (error) => {
                this.toastMessageService.emitChange(
                  this.commonUtil.translateText('ACCESS.DENIED.MSG' + tokenArr[3]) + 'success'
                );
                localStorage.removeItem('userRequestedURL');
                const errors = error.data;
                const errorCode = error.substring(errors.indexOf('Code: ') + 6, errors.indexOf('Code: ') + 10);
                if (errorCode === 2001) {
                  this.toastMessageService.emitChange(
                    this.commonUtil.translateText('ACCESS.APPROVED.ALREADY.MSG' + tokenArr[3]) + 'success'
                  );
                } else if (errorCode === 2002) {
                  this.toastMessageService.emitChange(
                    this.commonUtil.translateText('ACCESS.DENIED.ALREADY.MSG' + tokenArr[3]) + 'success'
                  );
                }
              }
            );
          }
        }
      }
    }
  }
}
